(() => {
  'use strict';
  const gate = document.getElementById('uae-age-access');
  if (!gate) return;
  const form = gate.querySelector('#uae-access-form');
  const monthEl = gate.querySelector('#uae-age-month');
  const dayEl = gate.querySelector('#uae-age-day');
  const yearEl = gate.querySelector('#uae-age-year');
  const errorEl = gate.querySelector('#uae-access-error');
  const exitEl = gate.querySelector('#uae-age-exit');
  const minimum = Math.max(18, Math.min(25, Number(gate.dataset.requiredAge) || 21));
  const cacheKey = 'uae-pure-verified-age-' + minimum;
  const expiryHours = 12;
  let lockedNodes = [];

  function hasVerifiedSession() {
    try {
      const value = Number(window.sessionStorage.getItem(cacheKey));
      return Number.isFinite(value) && value > Date.now();
    } catch (_) { return false; }
  }
  function markVerified() {
    try { window.sessionStorage.setItem(cacheKey, String(Date.now() + expiryHours * 60 * 60 * 1000)); } catch (_) {}
  }
  function lockPage() {
    document.body.classList.add('uae-age-locked');
    document.querySelectorAll('.page-wrapper, #header-group').forEach(node => {
      if (gate.contains(node)) return;
      lockedNodes.push({node, value:node.inert});
      node.inert = true;
    });
  }
  function unlockPage() {
    document.body.classList.remove('uae-age-locked');
    lockedNodes.forEach(({node,value}) => {node.inert = value;});
    lockedNodes = [];
  }
  function hide() {
    gate.hidden = true;
    unlockPage();
  }
  function showError(text) {
    errorEl.textContent = text;
    errorEl.hidden = false;
  }
  function clearError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
  }
  function ageQualified() {
    const year = Number(yearEl.value), month = Number(monthEl.value), day = Number(dayEl.value);
    if (!year || !month || !day) return {pass:false, message:'Please select your complete date of birth.'};
    if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900) return {pass:false, message:'Please enter a valid date of birth.'};
    const birth = new Date(year, month - 1, day);
    if (birth.getFullYear() !== year || birth.getMonth() !== month-1 || birth.getDate() !== day) {
      return {pass:false,message:'Please enter a valid date of birth.'};
    }
    const now = new Date();
    if (birth > now) return {pass:false,message:'Date of birth cannot be in the future.'};
    const latestAllowed = new Date(now.getFullYear()-minimum, now.getMonth(), now.getDate());
    if (birth > latestAllowed) return {pass:false,message:'You must be at least ' + minimum + ' years old to enter this website.'};
    return {pass:true};
  }
  const now = new Date();
  const thisYear = now.getFullYear();
  const fragment = document.createDocumentFragment();
  for (let y=thisYear; y>=Math.max(1900,thisYear-110);y--) {
    const option=document.createElement('option');
    option.value=String(y);
    option.textContent=String(y);
    fragment.appendChild(option);
  }
  yearEl.appendChild(fragment);
  if (hasVerifiedSession()) { hide(); return; }

  gate.hidden = false;
  lockPage();
  window.requestAnimationFrame(() => monthEl.focus({preventScroll:true}));
  form.addEventListener('submit',event => {
    event.preventDefault();
    clearError();
    const result = ageQualified();
    if (!result.pass) { showError(result.message); return; }
    markVerified();
    hide();
  });
  [monthEl,dayEl,yearEl].forEach(el => el.addEventListener('change',clearError));
  exitEl.addEventListener('click',() => {
    const url = gate.dataset.exitUrl || 'https://www.google.com/';
    try {
      const parsed = new URL(url,location.origin);
      if (parsed.protocol === 'https:' || parsed.protocol === 'http:') {
        if (parsed.origin === location.origin && !parsed.pathname.startsWith('/pages/age-exit')) {
          window.location.assign('https://www.google.com/');
        } else {
          window.location.assign(parsed.href);
        }
        return;
      }
    } catch (_) {}
    window.location.assign('https://www.google.com/');
  });
  gate.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      event.preventDefault();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = [...gate.querySelectorAll('select,button')].filter(el => !el.disabled);
    if (!items.length) return;
    if (event.shiftKey && document.activeElement === items[0]) {
      event.preventDefault();items[items.length-1].focus();
    } else if (!event.shiftKey && document.activeElement === items[items.length-1]) {
      event.preventDefault();items[0].focus();
    }
  });
})();